import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Toaster from "../../component/Toaster";
import TypographyLabel from "../../component/Typography";
import { dashboardAction } from "../../store/dashboard/dashboardSlice";
import dayjs from "dayjs";

export default function NewAdmition() {
  const { t } = useTranslation();
  const dispatch = useDispatch<any>();

  const [newAdmissionAndDropOut, setNewAdmissionAndDropOut] = useState<any>({});

  const getNewAdmissionAndDropOut = () => {
    dispatch(dashboardAction({ apiAction: "getNewAdmissionAndDropOut" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setNewAdmissionAndDropOut(result?.payload?.data?.data);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const months = Object.keys(newAdmissionAndDropOut).filter(
    (month) => month !== "dropoutPercentage"
  );

  const chartdata = {
    labels: months,
    datasets: [
      {
        label: "New Admission",
        data: months.map(
          (month) => newAdmissionAndDropOut[month]["New Admission"]
        ),
        backgroundColor: "#6FB8B8",
        borderRadius: 50,
        barThickness: 12,
        maxBarThickness: 40,
      },
      {
        label: "Dropout",
        data: months.map((month) => newAdmissionAndDropOut[month]["Dropout"]),
        backgroundColor: "#FF8383",
        borderRadius: 50,
        barThickness: 12,
        maxBarThickness: 40,
      },
      {
        label: "Passout",
        data: months.map((month) => newAdmissionAndDropOut[month]["Passout"]),
        backgroundColor: "#000080",
        borderRadius: 50,
        barThickness: 12,
        maxBarThickness: 40,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      display: true,
      legend: {
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
        },
        boxWidth: 6,
        position: "top" as const,
      },
    },
  };

  const getDropout = () => {
    // Calculate total registrations, total dropouts, and total passouts
    let totalRegistrations = 0;
    let totalDropouts = 0;

    Object.values(newAdmissionAndDropOut).forEach((monthData: any) => {
      totalRegistrations += monthData["New Admission"];
      totalDropouts += monthData["Dropout"];
    });

    const dropRate = (totalDropouts / totalRegistrations) * 100;
    return dropRate.toFixed(0) + "%";
  };

  useEffect(() => {
    getNewAdmissionAndDropOut();
  }, []);

  return (
    <div>
      <div className="flex justify-content-between ">
        <div className=" dashboard-heading padding-20">
          <div className="font-14 bolder">{t("newAdmissionDropout")}</div>
        </div>
      </div>
      <Bar options={options} data={chartdata} height={100} />
      {
        <Grid className=" " style={{ paddingTop: "20px" }}>
          <div style={{ width: "60%" }}>
            <div className=" admition-box ">
              <div className=" active-box ">
                <div className="active-title">
                  {newAdmissionAndDropOut?.dropoutPercentage
                    ?.dropoutPercentage || 0}{" "}
                  %
                </div>
                <div className="active-small-title">
                  <TypographyLabel title={t("dropout")} />
                  <span style={{ fontSize: "1-px" }}>
                    {dayjs().subtract(1, "year").format("MMMM YY")} to{" "}
                    {dayjs().subtract(1, "month").format("MMMM YY")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      }
    </div>
  );
}
